"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = exports.ApiSocket = void 0;
var fifty_seven_llc_protocol_1 = require("fifty-seven-llc-protocol");
var logger_1 = require("./logger");
var event_emitter_1 = require("./event-emitter");
var Types = {};
Object.assign(Types, fifty_seven_llc_protocol_1.TypesPb);
var Client = {};
Object.assign(Client, fifty_seven_llc_protocol_1.ClientPb);
var Server = {};
Object.assign(Server, fifty_seven_llc_protocol_1.ServerPb);
function genJenkinsHash(data) {
    var buffer = new Array(data.length);
    for (var i = 0; i < data.length; i++)
        buffer[i] = data.charCodeAt(i);
    var h = 0;
    for (var i = 0; i < buffer.length; i++) {
        h = (h + buffer[i]) >>> 0;
        h = (h + (h << 10)) >>> 0;
        h = (h ^ (h >>> 6)) >>> 0;
    }
    h = (h + (h << 3)) >>> 0;
    h = (h ^ (h >>> 11)) >>> 0;
    h = (h + (h << 15)) >>> 0;
    return h;
}
var ApiSocket = (function (_super) {
    __extends(ApiSocket, _super);
    function ApiSocket(_url) {
        var _this = _super.call(this) || this;
        _this._url = _url;
        _this._logger = new logger_1.Logger('ApiSocket');
        _this._packetsMap = new Map();
        _this._queue = [];
        _this._socket = null;
        _this._canSendData = false;
        _this._destroyed = false;
        _this._attempts = 0;
        _this._wrapPackets({ Types: Types, Client: Client, Server: Server }, 'FiftySeven.Protocol');
        _this.logger.trace('Initialized.');
        _this._socketOnConnect = _this._socketOnConnect.bind(_this);
        _this._socketOnDisconnect = _this._socketOnDisconnect.bind(_this);
        _this._socketOnError = _this._socketOnError.bind(_this);
        _this._socketOnMessage = _this._socketOnMessage.bind(_this);
        return _this;
    }
    ApiSocket.prototype.destroy = function () {
        this._destroyed = true;
        this._socket.close(1000);
        this._packetsMap.clear();
        this.fire('destroyed');
        _super.prototype.destroy.call(this);
        this.logger.trace('Destroyed.');
    };
    Object.defineProperty(ApiSocket.prototype, "logger", {
        get: function () {
            return this._logger;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSocket.prototype, "url", {
        get: function () {
            return this._url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSocket.prototype, "destroyed", {
        get: function () {
            return this._destroyed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSocket.prototype, "connected", {
        get: function () {
            return !!this._socket && this._socket.readyState === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSocket.prototype, "canSendData", {
        get: function () {
            return this._canSendData;
        },
        set: function (value) {
            this._canSendData = value;
            this._processQueue();
        },
        enumerable: false,
        configurable: true
    });
    ApiSocket.prototype._wrapPackets = function (packetsObject, prefix) {
        var _this = this;
        if (prefix === void 0) { prefix = ''; }
        Object.keys(packetsObject).forEach(function (key) {
            var path = (prefix ? prefix + '.' : '') + key;
            if (typeof packetsObject[key] === 'function' && key.charAt(0).match(/[A-Z]/)) {
                Object.defineProperty(packetsObject[key], 'name', { value: key });
                Object.defineProperty(packetsObject[key], 'path', { value: path });
                var hash = genJenkinsHash(path);
                _this._packetsMap.set(hash, packetsObject[key]);
                _this.logger.trace("Packet " + hash + " " + path + " was registered.");
            }
            _this._wrapPackets(packetsObject[key], path);
        });
    };
    ApiSocket.prototype._processQueue = function () {
        var _this = this;
        if (!this.connected)
            return;
        if (!this.canSendData)
            return;
        var message = this._queue[0];
        if (!message)
            return;
        this._processPacket(message);
        this._queue.shift();
        setTimeout(function () { return _this._processQueue(); }, 0);
    };
    ApiSocket.prototype._processPacket = function (message) {
        var _a;
        if (!this.connected)
            return;
        if (typeof message.serializeBinary !== 'function')
            return;
        var packet = new fifty_seven_llc_protocol_1.TypesPb.Packet();
        var packetId = (_a = __spread(this._packetsMap).find(function (i) { return i[1] === message['constructor']; })) === null || _a === void 0 ? void 0 : _a[0];
        packet.setId(packetId);
        packet.setBuffer(message.serializeBinary());
        this._socket.send(packet.serializeBinary());
        this.logger.trace('Message', message['constructor'].path, 'was sent.');
    };
    ApiSocket.prototype._socketOnConnect = function (e) {
        this._attempts = 0;
        this._logger.trace('Connected to server.');
        this._processQueue();
        this.fire('connected', e);
    };
    ApiSocket.prototype._socketOnDisconnect = function (e) {
        var _this = this;
        this.fire('disconnected', e);
        this._logger.trace("Disconnected from server with code " + e.code + ".");
        setTimeout(function () { return _this.connect(); }, 1000 * Math.min(this._attempts, 10));
    };
    ApiSocket.prototype._socketOnError = function (e) {
        this.fire('error', e.data);
        if (!this.destroyed)
            this.connect();
    };
    ApiSocket.prototype._socketOnMessage = function (e) {
        var _a;
        var packet = fifty_seven_llc_protocol_1.TypesPb.Packet.deserializeBinary(e.data);
        var messageType = this._packetsMap.get(packet.getId());
        var message = (_a = messageType === null || messageType === void 0 ? void 0 : messageType['deserializeBinary']) === null || _a === void 0 ? void 0 : _a.call(messageType, packet.getBuffer());
        this.logger.trace('Message', message['constructor'].path, 'was receive.');
        this.fire('message', message);
    };
    ApiSocket.prototype.connect = function () {
        if (this.destroyed)
            return;
        if (this.connected)
            return;
        if (this._socket) {
            this._socket.removeEventListener('open', this._socketOnConnect);
            this._socket.removeEventListener('close', this._socketOnDisconnect);
            this._socket.removeEventListener('error', this._socketOnError);
            this._socket.removeEventListener('message', this._socketOnMessage);
            this._socket.close();
        }
        this._socket = new WebSocket(this.url);
        this._socket.binaryType = 'arraybuffer';
        this._socket.addEventListener('open', this._socketOnConnect);
        this._socket.addEventListener('close', this._socketOnDisconnect);
        this._socket.addEventListener('error', this._socketOnError);
        this._socket.addEventListener('message', this._socketOnMessage);
        this._attempts++;
        this.logger.trace('Connecting to server. Attempt:', this._attempts);
    };
    ApiSocket.prototype.reconnect = function () {
        this._socket.close(1000);
    };
    ApiSocket.prototype.send = function (message, bypassQueue) {
        if (bypassQueue === void 0) { bypassQueue = false; }
        if (!bypassQueue) {
            if (this._queue.push(message) === 1)
                this._processQueue();
        }
        else {
            this._processPacket(message);
        }
    };
    ApiSocket.prototype.ping = function () {
        this.send(new fifty_seven_llc_protocol_1.ClientPb.Ping(), true);
    };
    return ApiSocket;
}(event_emitter_1.EventEmitter));
exports.ApiSocket = ApiSocket;
exports.api = new ApiSocket(process.env.VUE_APP_WEB_SOCKET_URL);
//# sourceMappingURL=api.js.map